import { getSupabase } from './client';

/**
 * @param {string} filter
 * @param {{ limit?: number; offset?: number }} [opts]
 */
export async function adminListBhriguQuestions(filter = 'suspicious', opts = {}) {
  const client = getSupabase();
  if (!client) throw new Error('Supabase not configured');
  const { data, error } = await client.rpc('stud_admin_list_bhrigu_questions', {
    p_filter: filter,
    p_limit: opts.limit ?? 50,
    p_offset: opts.offset ?? 0,
  });
  if (error) throw error;
  return data || [];
}

/** @param {string} questionId */
export async function adminDeleteBhriguQuestion(questionId) {
  const client = getSupabase();
  if (!client) throw new Error('Supabase not configured');
  const { error } = await client.rpc('stud_admin_delete_bhrigu_question', {
    p_question_id: questionId,
  });
  if (error) throw error;
}

/** @param {string} questionId */
export async function adminPublishBhriguQuestion(questionId) {
  const client = getSupabase();
  if (!client) throw new Error('Supabase not configured');
  const { error } = await client.rpc('stud_admin_publish_bhrigu_question', {
    p_question_id: questionId,
  });
  if (error) throw error;
}

/** @param {string} pageKey @param {number} [limit] */
export async function fetchPageChatMessages(pageKey, limit = 40) {
  const client = getSupabase();
  if (!client) throw new Error('Supabase not configured');
  const { data, error } = await client.rpc('stud_bhrigu_get_page_messages', {
    p_page_key: pageKey,
    p_limit: limit,
  });
  if (error) throw error;
  return data || [];
}
